<!-- SupplementInfoPanel.vue (Vue 2 + Element UI) -->
<template>
  <div class="supplement-panel">
    <div class="hint">
      Bạn vui lòng chọn các hồ sơ khách hàng cần bổ sung, chỉnh sửa trong danh sách bên dưới.
    </div>

    <div class="hint">Danh sách hồ sơ cần bổ sung, chỉnh sửa:</div>

    <el-table
        :data="rows"
        border
        size="small"
        class="supplement-table"
    >
      <el-table-column
          prop="label"
          label="Thông tin cần bổ sung"
          min-width="240"
      />

      <el-table-column
          label="Chọn"
          width="90"
          align="center"
      >
        <template slot-scope="scope">
          <el-checkbox v-model="scope.row.checked" />
        </template>
      </el-table-column>

      <el-table-column
          label="Mô tả"
          min-width="280"
      >
        <template slot-scope="scope">
          <el-input
              v-model="scope.row.note"
              size="mini"
              placeholder="Nhập mô tả..."
              :disabled="!scope.row.checked"
              clearable
          />
        </template>
      </el-table-column>
    </el-table>

    <div class="d-flex justify-content-end align-items-center mt-8">
      <el-button style="background-color: #CACACA" @click="$emit('close'); clear()" size="mini" class="rounded">Hủy bỏ</el-button>
      <el-button style="background-color: #5D04B0" @click="submit()" class="text-white rounded" :loading="loading" size="mini">Xác nhận</el-button>
    </div>
  </div>
</template>

<script>
import {
  GET_INFO_BORROWER,
  REQUEST_ADDITIONAL_CITIME
} from "../../../../core/services/store/customer/customer-crm.module";

export default {
  name: "request-additional",
  data() {
    return {
      loading: false,
      rows: [
            { key: "cccd", label: "Căn cước công dân", checked: false,  note: "" },
            { key: "ks",   label: "Giấy khai sinh của học viên", checked: false, note: "" },
            { key: "pt",   label: "Phiếu thu", checked: false, note: "" },
            { key: "cmtc", label: "Chứng minh tài chính", checked: false, note: "" },
            { key: "gm",   label: "Gmail", checked: false, note: "" },
            { key: "dc",   label: "Địa chỉ", checked: false, note: "" },
            { key: "sdt",  label: "Số điện thoại", checked: false, note: "" }
          ]
    };
  },
  watch: {
    rows: {
      deep: true,
      handler(val) {
        this.$emit("input", val);
      }
    }
  },
  methods: {
    clear() {
      for (let i = 0; i < this.rows.length; i++) {
        this.rows[i].checked = false;
        this.rows[i].note = "";
      }
    },

    submit() {
      this.loading = true;
      const selectedRows = this.rows.filter(r => r.checked);

      if (!selectedRows.length) {
        this.$notify({
          title: 'Thiếu dữ liệu!',
          message: 'Vui lòng chọn ít nhất 1 hồ sơ cần bổ sung.',
          type: 'warning'
        });
        this.loading = false;
        return;
      }

      const missingReasons = selectedRows.filter(r => !(r.note || '').trim());

      if (missingReasons.length) {
        this.$notify({
          title: 'Thiếu lý do!',
          message: `Vui lòng nhập lý do cho: ${missingReasons.map(r => r.label).join(', ')}`,
          type: 'warning'
        });
        this.loading = false;
        return;
      }

      const payload = {
        id: this.$route.params.id,
        documents: selectedRows.map(r => ({
          name: r.label,
          reason: r.note.trim()
        }))
      };

      this.$store.dispatch(REQUEST_ADDITIONAL_CITIME, payload)
          .then((res) => {
            this.history = res.data.processing_logs;
            this.$notify({
              title: 'Success',
              message: res.message || 'Yêu cầu bổ sung hồ sơ thành công!',
              type: 'success'
            });
            this.loading = false;
            this.$emit('close');
          })
          .catch((e) => {
            this.$notify({
              title: 'Thất bại!',
              message: e?.data?.message || 'Yêu cầu bổ sung hồ sơ thất bại!',
              type: 'error'
            });
          });
          this.loading = false;
    }

  }
};
</script>

<style scoped>
.supplement-panel {
  background: #fff;
  padding: 16px;
}

.hint {
  font-size: 13px;
  color: #333;
  margin-bottom: 10px;
}

.supplement-table {
  width: 100%;
}
</style>
